import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardTitle,
} from "@/components/ui/card";
import { useTranslation } from "react-i18next";

interface RequestIntegrationCardProps {
  onRequestIntegration: () => void;
}

export const RequestIntegrationCard = ({
  onRequestIntegration,
}: RequestIntegrationCardProps) => {
  const { t } = useTranslation();

  return (
    <Card className="bg-white border-gray-200 transition-shadow cursor-pointer dark:bg-slate-900 dark:border-slate-700 hover:shadow-md">
      <CardContent className="p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <CardTitle className="text-base font-semibold text-gray-900 dark:text-gray-50">
              {t("team.integrations.notFound.cardTitle")}
            </CardTitle>
          </div>
        </div>
        <CardDescription className="mb-4 text-sm text-gray-600 dark:text-gray-400">
          {t("team.integrations.notFound.cardDescription")}
        </CardDescription>
        <Button
          variant="default"
          size="sm"
          className="w-full"
          onClick={onRequestIntegration}
        >
          {t("team.integrations.notFound.button")}
        </Button>
      </CardContent>
    </Card>
  );
};
